import React, { useEffect, useState } from "react"

import { Row, Col } from "reactstrap"

// Pages Components
import Miniwidget from "./Miniwidget"
import ProfileViews from "./profileViews"
import Reach from "./reach"
import Impressions from "./impressions"
import Notifications from "./notifications"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import { useSelector, useDispatch, connect } from "react-redux"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"
import PostsList from "./posts_list"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
import SnackbarComponent from "components/SnackBar"
import axios from "axios"
import PostDetails from "./PostDetails"
import Chat from "./chat"
import CreatePost from "./CreatePost"

const FacebookDashboard = props => {
  const [pageDetails, setPageDetails] = useState(null)
  const [err, setErr] = useState(null)
  const [loading, setLoading] = useState(false)
  const [reviews, setReviews] = useState([])
  const [postClicked, setPostClicked] = useState(false)
  const [viewMode, setViewMode] = useState("Month")
  const [selectedPost, setSelectedPost] = useState(null)
  const [posts, setPosts] = useState([])
  const [reports, setReports] = useState([
    {
      title: "Followers",
      iconClass: "account-group",
      total: `0`,
      average: "+11%",
      badgecolor: "info",
    },
    {
      title: "Likes",
      iconClass: "thumb-up",
      total: `0`,
      average: "-29%",
      badgecolor: "danger",
    },
    {
      title: "Reviews",
      iconClass: "message-draw",
      total: `0`,
      average: "0%",
      badgecolor: "warning",
    },
    {
      title: "Rating",
      iconClass: "star",
      total: `0`,
      average: "+89%",
      badgecolor: "info",
    },
  ])
  const [success, setSuccess] = useState(null)
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  document.title = "Dashboard | Reputation Management"

  const breadcrumbItems = [
    {
      title: `${activeOrganization.name} (${activeOrganization.type})`,
      link: "/dashboard",
    },
    { title: "Instagram", link: "#" },
  ]

  const fetchInstagramInsights = async () => {
    try {
      // Fetch total followers, follows, and media count
      const totalFollowersResponse = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization.InstagramIntegrations[0].pageId}?fields=followers_count,follows_count,media_count&access_token=${activeOrganization.InstagramIntegrations[0].pageToken}`,
      )

      // Determine period based on viewMode
      const period = viewMode === "Month" ? "days_28" : "week"

      // Fetch reach data for the selected period
      const profileViewsResponse = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization.InstagramIntegrations[0].pageId}/insights?metric=reach&period=${period}&access_token=${activeOrganization.InstagramIntegrations[0].pageToken}`,
      )

      console.log("GGG", profileViewsResponse)

      // Extract current and previous values for Reach
      const reachValues = profileViewsResponse.data.data[0]?.values || []
      const currentReach = reachValues[1]?.value || 0
      const previousReach = reachValues[0]?.value || 0

      // Calculate signed percentage difference
      const calculatePercentageDifference = (current, previous) => {
        if (previous === 0) return "+0%" // Avoid division by zero
        const diff = ((current - previous) / previous) * 100
        const sign = diff > 0 ? "+" : ""
        return `${sign}${diff.toFixed(1)}%`
      }

      const reachPercentageDiff = calculatePercentageDifference(
        currentReach,
        previousReach,
      )
      const reachBadgeColor =
        currentReach >= previousReach ? "success" : "danger"

      // Set reports
      setReports([
        {
          title: "Followers",
          iconClass: "account-group",
          total: totalFollowersResponse.data.followers_count,
          average: null,
          badgecolor: "info",
        },
        {
          title: "Follows",
          iconClass: "thumb-up",
          total: totalFollowersResponse.data.follows_count,
          average: null,
          badgecolor: "info",
        },
        {
          title: "Posts Count",
          iconClass: "message-draw",
          total: totalFollowersResponse.data.media_count,
          average: null,
          badgecolor: "info",
        },
        {
          title: `Reach`,
          iconClass: "star",
          total: currentReach,
          average: reachPercentageDiff, // Signed percentage difference
          badgecolor: reachBadgeColor,
        },
      ])
    } catch (error) {
      console.error("Error fetching Instagram insights:", error)
      setErr("Error fetching Instagram insights.")
    }
  }

  const fetchPosts = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization.InstagramIntegrations[0].pageId}/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp&access_token=${activeOrganization.InstagramIntegrations[0].pageToken}`,
      )
      console.log("piosts", response.data.data)
      setPosts(response.data.data)
      setLoading(false)
    } catch (err) {
      setPosts(false)
      setErr("Error fetching posts.")
    }
  }

  useEffect(() => {
    props.setBreadcrumbItems(`Instagram`, breadcrumbItems)
    fetchPosts()
  }, [activeOrganization])

  useEffect(() => {
    fetchInstagramInsights()
  }, [activeOrganization, viewMode])

  return (
    <React.Fragment>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      {postClicked ? (
        <PostDetails
          post={selectedPost}
          setErr={setErr}
          setSuccess={setSuccess}
          setPostClicked={setPostClicked}
          setSelectedPost={setSelectedPost}
        />
      ) : (
        <>
          <Miniwidget
            reports={reports}
            setViewMode={setViewMode}
            viewMode={viewMode}
          />

          <Row>
            <Col xl="12">
              <Reach reviews={reviews} loading={loading} />
            </Col>

            {/* <Col xl="">
              <Impressions />
            </Col> */}
          </Row>
          <Row>
            <Col xl="12">
              <ProfileViews />
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <PostsList
                loading={loading}
                posts={posts}
                setPostClicked={setPostClicked}
                setSelectedPost={setSelectedPost}
              />
            </Col>
            {/* <Col xl={5}>
              <CreatePost />
            </Col> */}
          </Row>

          {/* <Row>
            <Col xl="4" lg="6">
              <Inbox />
            </Col>
            <Col xl="4" lg="6">
              <RecentActivity />
            </Col>
            <Col xl="4">
              <WidgetUser />
              <YearlySales />
            </Col>
          </Row> */}

          {/* <Row>
            <Col xl="12">
              <Chat setErr={setErr} />
            </Col>
          </Row> */}
        </>
      )}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(FacebookDashboard)
